let claims = ['Breeder','Cull', 'Donate', 'Experiment','Remove', 'Genotype'];
export { claims }